/**
 * Sidebar Webchat - Toggle Button + Sidebar Widget
 * Creates the "HELP ME PICK!" toggle in the header and the sliding sidebar panel.
 */

(function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────────────────── */
  function isMobile() {
    return window.innerWidth <= 767;
  }

  /* ── Inject sidebar HTML into <body> ─────────────────────────────────── */
  function injectSidebarHTML() {
    // Sidebar panel
    const sidebar = document.createElement('div');
    sidebar.id = 'sidebar';

    // Iframe pointing to sidebar.html asset — loaded eagerly so the Botpress
    // app can rehydrate the persisted conversationId and fetch message history
    // before the user opens the panel.
    const iframe = document.createElement('iframe');
    // The panel cannot read this page (cross-origin), so the page hands it the
    // language and, on a product page, the product name, through the hash. The
    // hash never reaches the server: one cached bundle serves every page.
    const ctx = ['lang=' + encodeURIComponent(window.SHOP_LOCALE || 'en')];
    if (window.ALIX_PRODUCT) ctx.push('product=' + encodeURIComponent(window.ALIX_PRODUCT));
    // Shop by mood pages (2026-10-07): Alix greets for that mood
    else if (window.ALIX_MOOD) ctx.push('mood=' + encodeURIComponent(window.ALIX_MOOD));
    iframe.src = (window.SIDEBAR_URL || '') + '#' + ctx.join('&');
    iframe.title = 'Upside Drinks Chat';
    iframe.setAttribute('allow', 'microphone');
    sidebar.appendChild(iframe);

    document.body.appendChild(sidebar);

    // Overlay
    const overlay = document.createElement('div');
    overlay.id = 'sidebar-overlay';
    document.body.appendChild(overlay);
  }

  /* ── Toggle button (existing HELP ME PICK style) ─────────────────────── */
  function createToggleButton() {
    const toggleBtn = document.createElement('button');
    toggleBtn.id = 'sidebar-webchat-toggle';
    toggleBtn.setAttribute('aria-label', 'Toggle sidebar chat');

    const locale = window.SHOP_LOCALE || 'en';
    const translations = { en: 'HELP ME PICK !', fr: 'AIDE-MOI CHOISIR !' };
    const text = translations[locale] || translations.en;

    toggleBtn.innerHTML = `
      <svg class="chat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        <circle cx="18.5" cy="4.5" r="5" fill="white" stroke="none"/>
        <line x1="18.5" y1="1" x2="18.5" y2="8" stroke="currentColor" stroke-width="2.5"/>
        <line x1="15" y1="4.5" x2="22" y2="4.5" stroke="currentColor" stroke-width="2.5"/>
      </svg>
      <span class="button-text">${text}</span>
    `;

    // Original Botpress integration targeted `.header-item--logo` and rewrote
    // its contents via a wrapper. Kept here as reference for the vendor:
    //
    // const headerLogo = document.querySelector('.header-item--logo');
    // if (headerLogo) {
    //   let wrapper = headerLogo.querySelector('.logo-beer-wrapper');
    //   if (!wrapper) {
    //     wrapper = document.createElement('div');
    //     wrapper.className = 'logo-beer-wrapper';
    //     wrapper.innerHTML = headerLogo.innerHTML;
    //     headerLogo.innerHTML = '';
    //     headerLogo.appendChild(wrapper);
    //   }
    //   wrapper.appendChild(toggleBtn);
    // }
    const webchatSlot = document.querySelector('.header-item--webchat');
    if (webchatSlot) {
      webchatSlot.appendChild(toggleBtn);
    } else {
      document.body.appendChild(toggleBtn);
    }

    return toggleBtn;
  }

  /* ── Sidebar open / close ────────────────────────────────────────────── */
  function openSidebar() {
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('sidebar-overlay');
    const toggle  = document.getElementById('sidebar-webchat-toggle');
    if (sidebar) sidebar.classList.add('open');
    if (overlay) overlay.classList.add('visible');
    if (toggle)  toggle.classList.add('hidden');
    document.body.classList.add('sidebar-open');
    try { sessionStorage.setItem('sidebar-open', '1'); } catch (e) {}
  }

  function closeSidebar() {
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('sidebar-overlay');
    const toggle  = document.getElementById('sidebar-webchat-toggle');
    if (sidebar) sidebar.classList.remove('open');
    if (overlay) overlay.classList.remove('visible');
    if (toggle)  toggle.classList.remove('hidden');
    document.body.classList.remove('sidebar-open');
    try { sessionStorage.removeItem('sidebar-open'); } catch (e) {}
  }

  /* ── Wire up events ──────────────────────────────────────────────────── */
  function bindEvents() {
    const toggle  = document.getElementById('sidebar-webchat-toggle');
    const overlay = document.getElementById('sidebar-overlay');

    if (toggle)  toggle.addEventListener('click', openSidebar);
    if (overlay) overlay.addEventListener('click', closeSidebar);

    /* postMessage bridge from iframe */
    window.addEventListener('message', function (e) {
      if (!e.data) return;

      if (e.data.type === 'bp:closeChat') {
        closeSidebar();
        return;
      }

      if (e.data.type !== 'bp:addToCart') return;

      var variantId = e.data.variantId;
      var quantity  = e.data.quantity || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        // Refresh cart count
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // Update any cart count badges the theme renders
        document.querySelectorAll(
          '.cart-count, .cart__count, [data-cart-count], .site-header__cart-count'
        ).forEach(function (el) { el.textContent = cart.item_count; });

        // Trigger the theme's own cart-refresh event (Expanse / standard themes)
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[addToCart] error', err);
      });
    });
  }

  /* ── Hide toggle when search is open ─────────────────────────────────── */
  function setupSearchListeners() {
    document.addEventListener('predictive-search:open', function () {
      const toggle = document.getElementById('sidebar-webchat-toggle');
      if (toggle) toggle.classList.add('search-open');
    });
    document.addEventListener('predictive-search:close-all', function () {
      const toggle = document.getElementById('sidebar-webchat-toggle');
      if (toggle) toggle.classList.remove('search-open');
    });
  }

  /* ── Boot ────────────────────────────────────────────────────────────── */
  function init() {
    injectSidebarHTML();
    createToggleButton();
    bindEvents();
    setupSearchListeners();

    // Re-open sidebar if it was open before page navigation
    try {
      if (sessionStorage.getItem('sidebar-open') === '1') {
        openSidebar();
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
